/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCommOut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m16.304 13.767-1.414-1.414 3.231-3.232H2.011v-2h16.232L14.89 3.767l1.414-1.414 5.707 5.707-1 1v.061h-.062zm-8.597 8L3.06 17.121h-.049v-.049L2 16.06l5.707-5.707 1.414 1.414-3.354 3.354h4.244v2H5.887l3.234 3.232zm12.304-4.646v-2h2v2zm-4 0v-2h2v2zm-4 0v-2h2v2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCommOut as CommOut };
